import Dexie,{} from "dexie";

export class indexDb extends Dexie{
    session!:Dexie.Table<sessionData,number>;
    constructor(){
        super("ogiec");
        this.version(1).stores({session:"name,value"});
    }
}
//const dexie = new Dexie("pcmng");

interface sessionData{
    name:string,
    value:string,
}